import React, { useEffect, useState, useRef } from "react";
import api from "../../api/api";
import "../../css/Employee.css";

const LeaveDetails = () => {
  const [orderData, setOrderData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [employeesPerPage, setEmployeesPerPage] = useState(10);
  const [showListFilter, setShowListFilter] = useState(false);
  const [zoomImageUrl, setZoomImageUrl] = useState(null);

  // For status editing
  const [editingStatusId, setEditingStatusId] = useState(null);
  const [updatedStatus, setUpdatedStatus] = useState("");

  const listFilterRef = useRef(null);

  useEffect(() => {
    api
      .get("/employee/leave/list")
      .then((response) => {
        if (response.data.success) {
          setOrderData(response.data.data);
          setFilteredData(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching leave requests:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    let dataToFilter = orderData;

    if (searchTerm.trim() !== "") {
      const search = searchTerm.toLowerCase();
      dataToFilter = orderData.filter((leave) => {
        return (
          (leave.employee_name || "").toLowerCase().includes(search) ||
          (leave.phone || "").toLowerCase().includes(search) ||
          (leave.email || "").toLowerCase().includes(search) ||
          (leave.department_name || "").toLowerCase().includes(search) ||
          (leave.company_name || "").toLowerCase().includes(search) ||
          (leave.start_date || "").toLowerCase().includes(search) ||
          (leave.end_date || "").toLowerCase().includes(search) ||
          (leave.status || "").toLowerCase().includes(search) ||
          (leave.reason || "").toLowerCase().includes(search)
        );
      });
    }

    setFilteredData(dataToFilter);
    setCurrentPage(1);
  }, [searchTerm, orderData]);

  const indexOfLastEmployee = currentPage * employeesPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
  const currentEmployees = filteredData.slice(
    indexOfFirstEmployee,
    indexOfLastEmployee
  );
  const totalPages = Math.ceil(filteredData.length / employeesPerPage);

  const handlePerPageChange = (value) => {
    setEmployeesPerPage(value);
    setShowListFilter(false);
    setCurrentPage(1);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        listFilterRef.current &&
        !listFilterRef.current.contains(event.target)
      ) {
        setShowListFilter(false);
      }
      // Also close status dropdown if clicked outside it
      if (
        !event.target.closest(".status-dropdown") &&
        !event.target.closest(".edit-icon-btn")
      ) {
        setEditingStatusId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeZoomModal = () => {
    setZoomImageUrl(null);
  };

  return (
    <section className="employee-section">
      <div className="inner-content">
        <div className="filter-wrapper">
          <h2>Leave Details</h2>
          <div className="right-filter">
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div
              className="list-fliter tooltip-wrapper"
              ref={listFilterRef}
              data-tooltip="Filter by List"
            >
              <button onClick={() => setShowListFilter(!showListFilter)}>
                <i className="fa-solid fa-filter"></i>
              </button>
              {showListFilter && (
                <div className="filter-data">
                  {[10, 30, 50, 100].map((number) => (
                    <div
                      key={number}
                      className={`filter-option ${
                        employeesPerPage === number ? "selected" : ""
                      }`}
                      onClick={() => handlePerPageChange(number)}
                    >
                      {number}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="table-wrapper">
              <table className="employee-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Employee Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Company</th>
                    <th>Department</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Days</th>
                    <th>Reason</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentEmployees.map((leave, index) => (
                    <tr key={index}>
                      <td>{indexOfFirstEmployee + index + 1}</td>
                      <td>{leave.employee_name || "N/A"}</td>
                      <td className="check-in">{leave.email || "N/A"}</td>
                      <td className="phone">
                        <i className="fa-solid fa-phone"></i>&nbsp;
                        {leave.phone || "N/A"}
                      </td>
                      <td className="p-day">{leave.company_name || "N/A"}</td>
                      <td>{leave.department_name || "N/A"}</td>
                      <td className="p-day">{leave.start_date || "N/A"}</td>
                      <td className="check-in">{leave.end_date || "N/A"}</td>
                      <td>{leave.days || "N/A"}</td>
                      <td>{leave.reason || "N/A"}</td>

                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            justifyContent: "space-between",
                          }}
                        >
                          <span
                            className="status"
                            style={{
                              color:
                                leave.status === "Accepted"
                                  ? "#28a745" // green
                                  : leave.status === "Pending"
                                  ? "#ff9d17" // yellow
                                  : leave.status === "Rejected"
                                  ? "#e74c3c" // red
                                  : "#000", // default black
                              fontWeight: "bold",
                            }}
                          >
                            {leave.status || "-"}
                          </span>
                          <button
                            className="edit-icon-btn"
                            onClick={() => {
                              setEditingStatusId(leave.id);
                              setUpdatedStatus(leave.status);
                            }}
                            title="Edit status"
                          >
                            <i class="fa-solid fa-pen-to-square"></i>
                          </button>
                        </div>

                        {editingStatusId === leave.id && (
                          <div className="status-dropdown">
                            <select
                              value={updatedStatus}
                              onChange={(e) => {
                                const newStatus = e.target.value;
                                setUpdatedStatus(newStatus);
                                api
                                  .post("/employee/status/update", {
                                    id: leave.id,
                                    status: newStatus,
                                  })
                                  .then((response) => {
                                    if (response.data.success) {
                                      const updatedData = orderData.map(
                                        (item) =>
                                          item.id === leave.id
                                            ? { ...item, status: newStatus }
                                            : item
                                      );
                                      setOrderData(updatedData);
                                      setFilteredData(updatedData);
                                      setEditingStatusId(null);
                                    } else {
                                      alert("Failed to update status.");
                                    }
                                  })
                                  .catch((error) => {
                                    console.error(
                                      "Status update failed:",
                                      error
                                    );
                                    alert("Error updating status.");
                                  });
                              }}
                              className="custom-select"
                              autoFocus
                            >
                              <option value="Accepted">Accepted</option>
                              <option value="Rejected">Rejected</option>
                              <option value="Pending">Pending</option>
                            </select>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="pagination">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </>
        )}

        {zoomImageUrl && (
          <div className="zoom-modal-overlay" onClick={closeZoomModal}>
            <div
              className="zoom-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="close-btn" onClick={closeZoomModal}>
                <i className="fa-solid fa-xmark"></i>
              </button>
              <img src={zoomImageUrl} alt="Zoomed" className="zoomed-image" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default LeaveDetails;
